import _ from 'lodash';
import LobCoveragesTransformationHelper from 'edge/quoteandbind/common/directives/CommonOfferingSelection/util/LobCoveragesTransformationHelper';

function HoCoveragesTransformationHelper($filter, offeringUtilFunctions) {
    LobCoveragesTransformationHelper.call(this, $filter, offeringUtilFunctions);
}

/**
 * Updates the coverage array models on the util
 * @public
 */
HoCoveragesTransformationHelper.prototype.updateModels = function () {
    var _this = this;

    this.offeringUtilFunctions.getLobData().updateModel();

    var lineCoverages = this.offeringUtilFunctions.getLobData().lineCoverageArray;
    var additionalCoverages = this.offeringUtilFunctions.getLobData().additionalCoverageArray;
    this.coverageArray = this.transformCoverageArray(lineCoverages);
    this.additionalCoverageArray = this.transformCoverageArray(additionalCoverages);
    var offeredQuotes = this.offeringUtilFunctions.getOfferedQuotes();
    this.offeringHeaders = _.sortBy(offeredQuotes, function (offering) {
        return offering.branchCode;
    });
    this.schedulesModel = this.offeringUtilFunctions.getLobData().schedulesArray.map(function (offering) {
        return {
            onChange: _this.onChange(offering.branch),
            model: offering,
            isLoading: _this.isLoading(offering.branch)
        };
    });
    var offerings = this.offeringUtilFunctions.getLobOfferings();
    this.mobileCoverageData = offerings.map(buildMobileCoverageData.bind(this));
};

function buildMobileCoverageData(offering) {
    var _this2 = this;

    var offeringCov = {};
    offeringCov.branchName = offering.branchName;
    offeringCov.baseCoverages = [];
    offeringCov.additionalCoverages = [];
    offering.coverages.baseCoverages.forEach(function (baseCoverage) {
        var baseCoverageState = {};
        baseCoverageState.infoVisible = false;
        if (!baseCoverage.terms) {
            baseCoverageState.coverage = baseCoverage;
        } else {
            var cov = _this2.createCoverage(baseCoverage);
            baseCoverageState.coverage = cov;
        }
        offeringCov.baseCoverages.push(baseCoverageState);
    });
    offering.coverages.additionalCoverages.forEach(function (addCoverage) {
        var addCoverageState = {};
        addCoverageState.infoVisible = false;
        if (!addCoverage.terms) {
            addCoverageState.coverage = addCoverage;
        } else {
            var addCov = _this2.createCoverage(addCoverage);
            addCoverageState.coverage = addCov;
        }
        offeringCov.additionalCoverages.push(addCoverageState);
    });
    return offeringCov;
}

/**
 * Gets the base (line) coverage array table
 * @returns {*|Array}
 */
HoCoveragesTransformationHelper.prototype.getBaseCoverageData = function () {
    return this.coverageArray;
};

/**
 * Gets the Lob specific coverables -> coverages tables. For HO this will be an array of coverages
 * @returns {*|Array}
 */
HoCoveragesTransformationHelper.prototype.getLobCoverageData = function () {
    return this.additionalCoverageArray;
};

HoCoveragesTransformationHelper.prototype.getOfferingHeaders = function () {
    return this.offeringHeaders;
};

HoCoveragesTransformationHelper.prototype.getSchedulesModel = function () {
    return this.schedulesModel;
};

HoCoveragesTransformationHelper.prototype.getLobCoverageName = function () {
    return 'baseCoverages';
};

export default HoCoveragesTransformationHelper;


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./common/js/src/edge/quoteandbind/ho/directives/HoOfferingSelection/util/HoCoveragesTransformationHelper.js
// module id = 477
// module chunks = 0